var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{staticClass:"u-icon",class:['u-icon--' + _vm.labelPos],on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.clickHandler).apply(void 0, arguments)
}}},[(_vm.isImg)?_c('v-uni-image',{staticClass:"u-icon__img",style:([_vm.imgStyle, _vm.$u.addStyle(_vm.customStyle)]),attrs:{"src":_vm.name,"mode":_vm.imgMode}}):_c('v-uni-text',{staticClass:"u-icon__icon",class:_vm.uClasses,style:([_vm.iconStyle, _vm.$u.addStyle(_vm.customStyle)]),attrs:{"hover-class":_vm.hoverClass}},[_vm._v(_vm._s(_vm.icon))]),(_vm.label !== '')?_c('v-uni-text',{staticClass:"u-icon__label",style:({
		color: _vm.labelColor,
		fontSize: _vm.$u.addUnit(_vm.labelSize),
		marginLeft: _vm.labelPos == 'right' ? _vm.$u.addUnit(_vm.space) : 0,
		marginTop: _vm.labelPos == 'bottom' ? _vm.$u.addUnit(_vm.space) : 0,
		marginRight: _vm.labelPos == 'left' ? _vm.$u.addUnit(_vm.space) : 0,
		marginBottom: _vm.labelPos == 'top' ? _vm.$u.addUnit(_vm.space) : 0,
	})},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }